import patientListService from '@/services/patientListService';

/**
 * Get all clinics associated with a customer
 * @param {Object} payload - Request payload
 * @param {string[]} payload.customer_ids - Array of customer ID strings
 * @returns {Promise} Response with customer_clinics array
 */
export function getCustomerClinicsApi(payload) {
  return patientListService.post('valogin/listCustomerAllClinics', payload);
}

/**
 * Switch user's current clinic context and get new JWT token
 * @param {Object} params - Query parameters
 * @param {string} params.token - Current JWT token
 * @param {string} params.clinic_id - Target clinic ID (string)
 * @returns {Promise} Response with new token
 */
export function switchClinicForCustomerApi(params) {
  return patientListService.get('valogin/transferCustomerClinic', { params });
}
